import { useEffect } from 'react';

import { useCurrentLocale } from '@/core/providers/I18nProvider';

type IdenfyResponse = {
	status: 'approved' | 'failed' | 'unverified';
	manualStatus: 'approved' | 'failed' | 'waiting' | null;
	autoSuspected: boolean;
	manualSuspected: boolean;
};

interface LivenessCheckProps {
	livenessCheckData: { serviceKind: string; webToken: string };
	onFinish: (response: IdenfyResponse) => void;
}

export const LivenessCheck = ({ livenessCheckData, onFinish }: LivenessCheckProps) => {
	const currentLocale = useCurrentLocale();

	useEffect(() => {
		const handleLivenessCheckMessage = async ({ data }: MessageEvent<IdenfyResponse>) => {
			if (
				data.status === 'approved' ||
				data.status === 'failed' ||
				data.manualStatus === 'approved' ||
				data.manualStatus === 'failed'
			) {
				onFinish(data);
			}
		};

		window.addEventListener('message', handleLivenessCheckMessage, false);

		return () => {
			window.removeEventListener('message', handleLivenessCheckMessage, false);
		};
	}, [onFinish]);

	return (
		<iframe
			id="iframe"
			allowFullScreen
			height="900px"
			width="100%"
			src={`https://ui.idenfy.com/?authToken=${livenessCheckData.webToken}&lang=${currentLocale}`}
			allow="camera"
			style={{ border: 'none', borderRadius: '4px' }}
		/>
	);
};
